/* eslint-disable @typescript-eslint/no-explicit-any */
export const UserPermissionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="22px"
    viewBox="0 -960 960 960"
    width="22px"
    fill="#8200BF"
  >
    <path d="M120-160v-112q0-34 17.5-62.5T184-378q62-31 126-46.5T440-440q20 0 40 1.5t40 4.5q-4 58 21 109.5t73 84.5v80H120ZM760-40l-60-60v-186q-44-13-72-49.5T600-420q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-290l50 50-60 60 60 60-80 80ZM440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm300 80q17 0 28.5-11.5T780-440q0-17-11.5-28.5T740-480q-17 0-28.5 11.5T700-440q0 17 11.5 28.5T740-400Z" />
  </svg>
);

export const CustomerLimitIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#8200BF"
  >
    <path d="M200-640h560v-80H200v80Zm0 0v-80 80Zm0 560q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880q17 0 28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880q17 0 28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v187q0 17-11.5 28.5T800-493q-17 0-28.5-11.5T760-533v-27H200v400h232q17 0 28.5 11.5T472-120q0 17-11.5 28.5T432-80H200Zm520 40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm20-208v-92q0-8-6-14t-14-6q-8 0-14 6t-6 14v91q0 8 3 15.5t9 13.5l61 61q6 6 14 6t14-6q6-6 6-14t-6-14l-61-61Z" />
  </svg>
);

export const TableMoreIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_14336_70732"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_14336_70732)">
      <path
        d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z"
        fill="#9103E4"
      />
    </g>
  </svg>
);

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="#8200BF"
  >
    <path d="M360-240q-29.7 0-50.85-21.15Q288-282.3 288-312v-480q0-29.7 21.15-50.85Q330.3-864 360-864h384q29.7 0 50.85 21.15Q816-821.7 816-792v480q0 29.7-21.15 50.85Q773.7-240 744-240H360Zm0-72h384v-480H360v480ZM216-96q-29.7 0-50.85-21.15Q144-138.3 144-168v-552h72v552h456v72H216Zm144-216v-480 480Z" />
  </svg>
);

export const UserIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12.8C18.2603 12.8 16.85 14.2103 16.85 15.95C16.85 17.6897 18.2603 19.1 20 19.1C21.7397 19.1 23.15 17.6897 23.15 15.95C23.15 14.2103 21.7397 12.8 20 12.8ZM15.05 15.95C15.05 13.2162 17.2662 11 20 11C22.7338 11 24.95 13.2162 24.95 15.95C24.95 18.6838 22.7338 20.9 20 20.9C17.2662 20.9 15.05 18.6838 15.05 15.95ZM20 24.5C17.1279 24.5 14.504 25.7501 12.5548 27.8174C12.2139 28.1791 11.6443 28.1958 11.2826 27.8548C10.9209 27.5139 10.9042 26.9443 11.2452 26.5826C13.5004 24.1906 16.5847 22.7 20 22.7C23.4153 22.7 26.4996 24.1906 28.7548 26.5826C29.0958 26.9443 29.0791 27.5139 28.7174 27.8548C28.3557 28.1958 27.7861 28.1791 27.4452 27.8174C25.496 25.7501 22.8721 24.5 20 24.5Z"
      fill="#84919A"
    />
  </svg>
);

export const MoneyIconSmall = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_18312_167853"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18312_167853)">
      <path
        d="M11.975 19.001C12.2083 19.001 12.4125 18.9135 12.5875 18.7385C12.7625 18.5635 12.85 18.3593 12.85 18.126V17.751C13.6833 17.601 14.4 17.276 15 16.776C15.6 16.276 15.9 15.5343 15.9 14.551C15.9 13.851 15.7 13.2093 15.3 12.626C14.9 12.0426 14.1 11.5343 12.9 11.101C11.9 10.7676 11.2083 10.476 10.825 10.226C10.4417 9.97598 10.25 9.63431 10.25 9.20098C10.25 8.76764 10.4042 8.42598 10.7125 8.17598C11.0208 7.92598 11.4667 7.80098 12.05 7.80098C12.3833 7.80098 12.675 7.85931 12.925 7.97598C13.175 8.09264 13.3833 8.25098 13.55 8.45098C13.7167 8.65098 13.9042 8.78848 14.1125 8.86348C14.3208 8.93848 14.5167 8.93431 14.7 8.85098C14.95 8.75098 15.1208 8.58014 15.2125 8.33848C15.3042 8.09681 15.2833 7.87598 15.15 7.67598C14.8833 7.29264 14.5542 6.96764 14.1625 6.70098C13.7708 6.43431 13.35 6.28431 12.9 6.25098V5.87598C12.9 5.64264 12.8125 5.43848 12.6375 5.26348C12.4625 5.08848 12.2583 5.00098 12.025 5.00098C11.7917 5.00098 11.5875 5.08848 11.4125 5.26348C11.2375 5.43848 11.15 5.64264 11.15 5.87598V6.25098C10.3167 6.43431 9.66667 6.80098 9.2 7.35098C8.73333 7.90098 8.5 8.51764 8.5 9.20098C8.5 9.98431 8.72917 10.6176 9.1875 11.101C9.64583 11.5843 10.3667 12.001 11.35 12.351C12.4 12.7343 13.1292 13.076 13.5375 13.376C13.9458 13.676 14.15 14.0676 14.15 14.551C14.15 15.101 13.9542 15.5051 13.5625 15.7635C13.1708 16.0218 12.7 16.151 12.15 16.151C11.7167 16.151 11.325 16.0468 10.975 15.8385C10.625 15.6301 10.3333 15.3176 10.1 14.901C9.96667 14.6676 9.79167 14.5093 9.575 14.426C9.35833 14.3426 9.14167 14.3426 8.925 14.426C8.69167 14.5093 8.52083 14.6676 8.4125 14.901C8.30417 15.1343 8.3 15.3593 8.4 15.576C8.66667 16.1426 9.025 16.6051 9.475 16.9635C9.925 17.3218 10.4667 17.5676 11.1 17.701V18.126C11.1 18.3593 11.1875 18.5635 11.3625 18.7385C11.5375 18.9135 11.7417 19.001 11.975 19.001ZM12 22.001C10.6167 22.001 9.31667 21.7385 8.1 21.2135C6.88333 20.6885 5.825 19.976 4.925 19.076C4.025 18.176 3.3125 17.1176 2.7875 15.901C2.2625 14.6843 2 13.3843 2 12.001C2 10.6176 2.2625 9.31764 2.7875 8.10098C3.3125 6.88431 4.025 5.82598 4.925 4.92598C5.825 4.02598 6.88333 3.31348 8.1 2.78848C9.31667 2.26348 10.6167 2.00098 12 2.00098C13.3833 2.00098 14.6833 2.26348 15.9 2.78848C17.1167 3.31348 18.175 4.02598 19.075 4.92598C19.975 5.82598 20.6875 6.88431 21.2125 8.10098C21.7375 9.31764 22 10.6176 22 12.001C22 13.3843 21.7375 14.6843 21.2125 15.901C20.6875 17.1176 19.975 18.176 19.075 19.076C18.175 19.976 17.1167 20.6885 15.9 21.2135C14.6833 21.7385 13.3833 22.001 12 22.001Z"
        fill="#9103E4"
      />
    </g>
  </svg>
);

export const CashIconMini = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18312_167861)">
      <path
        d="M16.2656 8.53125C12.0009 8.53125 8.53125 12.0009 8.53125 16.2656C8.53125 20.5304 12.0009 24 16.2656 24C20.5304 24 24 20.5304 24 16.2656C24 12.0009 20.5304 8.53125 16.2656 8.53125ZM16.2656 15.5625C17.4288 15.5625 18.375 16.5087 18.375 17.6719C18.375 18.5873 17.7854 19.3605 16.9688 19.6517V21.1875H15.5625V19.6517C14.7458 19.3605 14.1562 18.5873 14.1562 17.6719H15.5625C15.5625 18.0598 15.8777 18.375 16.2656 18.375C16.6536 18.375 16.9688 18.0598 16.9688 17.6719C16.9688 17.2839 16.6536 16.9688 16.2656 16.9688C15.1025 16.9688 14.1562 16.0225 14.1562 14.8594C14.1562 13.9439 14.7458 13.1708 15.5625 12.8795V11.3438H16.9688V12.8795C17.7854 13.1708 18.375 13.9439 18.375 14.8594H16.9688C16.9688 14.4714 16.6536 14.1562 16.2656 14.1562C15.8777 14.1562 15.5625 14.4714 15.5625 14.8594C15.5625 15.2473 15.8777 15.5625 16.2656 15.5625Z"
        fill="#9103E4"
      />
      <path
        d="M7.82812 8.53125C12.165 8.53125 15.5625 6.678 15.5625 4.3125C15.5625 1.947 12.165 0 7.82812 0C3.49125 0 0 1.947 0 4.3125C0 6.678 3.49125 8.53125 7.82812 8.53125Z"
        fill="#9103E4"
      />
      <path
        d="M0 15.8232V16.9689C0 19.3344 3.49125 21.1877 7.82812 21.1877C8.07413 21.1877 8.31248 21.165 8.55469 21.1532C8.01534 20.3051 7.61311 19.3642 7.37625 18.3582C4.24008 18.2717 1.51697 17.308 0 15.8232Z"
        fill="#9103E4"
      />
      <path
        d="M7.1588 16.9331C7.14267 16.7119 7.125 16.491 7.125 16.2658C7.125 15.5328 7.22105 14.8234 7.38483 14.1399C4.24477 14.0548 1.51833 13.0906 0 11.6045V12.7502C0 14.9902 3.15291 16.7506 7.1588 16.9331Z"
        fill="#9103E4"
      />
      <path
        d="M7.82812 12.7502C7.82888 12.7502 7.82948 12.7501 7.83028 12.7501C8.29402 11.6418 8.96813 10.6427 9.80527 9.80557C9.17025 9.88582 8.514 9.93766 7.82812 9.93766C4.48983 9.93766 1.59028 8.94218 0 7.38574V8.53141C0 10.8969 3.49125 12.7502 7.82812 12.7502Z"
        fill="#9103E4"
      />
    </g>
    <defs>
      <clipPath id="clip0_18312_167861">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentMiniIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_18317_167945"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18317_167945)">
      <path
        d="M3 20C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18V8C1 7.71667 1.09583 7.47917 1.2875 7.2875C1.47917 7.09583 1.71667 7 2 7C2.28333 7 2.52083 7.09583 2.7125 7.2875C2.90417 7.47917 3 7.71667 3 8V18H19C19.2833 18 19.5208 18.0958 19.7125 18.2875C19.9042 18.4792 20 18.7167 20 19C20 19.2833 19.9042 19.5208 19.7125 19.7125C19.5208 19.9042 19.2833 20 19 20H3ZM7 16C6.45 16 5.97917 15.8042 5.5875 15.4125C5.19583 15.0208 5 14.55 5 14V6C5 5.45 5.19583 4.97917 5.5875 4.5875C5.97917 4.19583 6.45 4 7 4H21C21.55 4 22.0208 4.19583 22.4125 4.5875C22.8042 4.97917 23 5.45 23 6V14C23 14.55 22.8042 15.0208 22.4125 15.4125C22.0208 15.8042 21.55 16 21 16H7ZM9 14C9 13.45 8.80417 12.9792 8.4125 12.5875C8.02083 12.1958 7.55 12 7 12V14H9ZM19 14H21V12C20.45 12 19.9792 12.1958 19.5875 12.5875C19.1958 12.9792 19 13.45 19 14ZM14 13C14.8333 13 15.5417 12.7083 16.125 12.125C16.7083 11.5417 17 10.8333 17 10C17 9.16667 16.7083 8.45833 16.125 7.875C15.5417 7.29167 14.8333 7 14 7C13.1667 7 12.4583 7.29167 11.875 7.875C11.2917 8.45833 11 9.16667 11 10C11 10.8333 11.2917 11.5417 11.875 12.125C12.4583 12.7083 13.1667 13 14 13ZM7 8C7.55 8 8.02083 7.80417 8.4125 7.4125C8.80417 7.02083 9 6.55 9 6H7V8ZM21 8V6H19C19 6.55 19.1958 7.02083 19.5875 7.4125C19.9792 7.80417 20.45 8 21 8Z"
        fill="#9103E4"
      />
    </g>
  </svg>
);

export const ContractMiniIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_18317_167976"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18317_167976)">
      <path
        d="M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V18C3 17.45 3.19583 16.9792 3.5875 16.5875C3.97917 16.1958 4.45 16 5 16H6V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H19C19.55 2 20.0208 2.19583 20.4125 2.5875C20.8042 2.97917 21 3.45 21 4V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4H8V16H15C15.55 16 16.0208 16.1958 16.4125 16.5875C16.8042 16.9792 17 17.45 17 18V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM10 9C9.71667 9 9.47917 8.90417 9.2875 8.7125C9.09583 8.52083 9 8.28333 9 8C9 7.71667 9.09583 7.47917 9.2875 7.2875C9.47917 7.09583 9.71667 7 10 7H17C17.2833 7 17.5208 7.09583 17.7125 7.2875C17.9042 7.47917 18 7.71667 18 8C18 8.28333 17.9042 8.52083 17.7125 8.7125C17.5208 8.90417 17.2833 9 17 9H10ZM10 12C9.71667 12 9.47917 11.9042 9.2875 11.7125C9.09583 11.5208 9 11.2833 9 11C9 10.7167 9.09583 10.4792 9.2875 10.2875C9.47917 10.0958 9.71667 10 10 10H17C17.2833 10 17.5208 10.0958 17.7125 10.2875C17.9042 10.4792 18 10.7167 18 11C18 11.2833 17.9042 11.5208 17.7125 11.7125C17.5208 11.9042 17.2833 12 17 12H10Z"
        fill="#9103E4"
      />
    </g>
  </svg>
);

export const PrevArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z" />
  </svg>
);

export const NextArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z" />
  </svg>
);

export const CashStarsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_25350_6861"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_25350_6861)">
      <path
        d="M11.999 17.2752L7.84904 19.7752C7.66571 19.8919 7.47404 19.9419 7.27404 19.9252C7.07404 19.9085 6.89904 19.8419 6.74904 19.7252C6.59904 19.6085 6.48237 19.4627 6.39904 19.2877C6.31571 19.1127 6.29904 18.9169 6.34904 18.7002L7.44904 13.9752L3.77404 10.8002C3.60737 10.6502 3.50321 10.4794 3.46154 10.2877C3.41987 10.096 3.43237 9.90853 3.49904 9.72519C3.56571 9.54186 3.66571 9.39186 3.79904 9.2752C3.93237 9.15853 4.11571 9.08353 4.34904 9.0502L9.19904 8.6252L11.074 4.1752C11.1574 3.9752 11.2865 3.8252 11.4615 3.7252C11.6365 3.6252 11.8157 3.5752 11.999 3.5752C12.1824 3.5752 12.3615 3.6252 12.5365 3.7252C12.7115 3.8252 12.8407 3.9752 12.924 4.1752L14.799 8.6252L19.649 9.0502C19.8824 9.08353 20.0657 9.15853 20.199 9.2752C20.3324 9.39186 20.4324 9.54186 20.499 9.72519C20.5657 9.90853 20.5782 10.096 20.5365 10.2877C20.4949 10.4794 20.3907 10.6502 20.224 10.8002L16.549 13.9752L17.649 18.7002C17.699 18.9169 17.6824 19.1127 17.599 19.2877C17.5157 19.4627 17.399 19.6085 17.249 19.7252C17.099 19.8419 16.924 19.9085 16.724 19.9252C16.524 19.9419 16.3324 19.8919 16.149 19.7752L11.999 17.2752Z"
        fill="#F8C51B"
      />
    </g>
  </svg>
);

export const EmptyCashIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_25360_53470"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <rect width="80" height="80" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_25360_53470)">
      <path
        d="M20.0006 66.6667C20.0006 67.6111 19.6812 68.4028 19.0423 69.0417C18.4034 69.6806 17.6118 70 16.6673 70H6.66732C5.72287 70 4.93121 69.6806 4.29232 69.0417C3.65343 68.4028 3.33398 67.6111 3.33398 66.6667V56.6667C3.33398 55.7222 3.65343 54.9306 4.29232 54.2917C4.93121 53.6528 5.72287 53.3333 6.66732 53.3333C7.61176 53.3333 8.40343 53.6528 9.04232 54.2917C9.68121 54.9306 10.0007 55.7222 10.0007 56.6667V63.3333H16.6673C17.6118 63.3333 18.4034 63.6528 19.0423 64.2917C19.6812 64.9306 20.0006 65.7222 20.0006 66.6667ZM73.334 53.3333C74.2784 53.3333 75.0701 53.6528 75.709 54.2917C76.3479 54.9306 76.6673 55.7222 76.6673 56.6667V66.6667C76.6673 67.6111 76.3479 68.4028 75.709 69.0417C75.0701 69.6806 74.2784 70 73.334 70H63.334C62.3895 70 61.5979 69.6806 60.959 69.0417C60.3201 68.4028 60.0006 67.6111 60.0006 66.6667C60.0006 65.7222 60.3201 64.9306 60.959 64.2917C61.5979 63.6528 62.3895 63.3333 63.334 63.3333H70.0006V56.6667C70.0006 55.7222 70.3201 54.9306 70.959 54.2917C71.5979 53.6528 72.3895 53.3333 73.334 53.3333ZM15.0007 60C14.5562 60 14.1673 59.8333 13.834 59.5C13.5007 59.1667 13.334 58.7778 13.334 58.3333V21.6667C13.334 21.2222 13.5007 20.8333 13.834 20.5C14.1673 20.1667 14.5562 20 15.0007 20H18.334C18.7784 20 19.1673 20.1667 19.5006 20.5C19.834 20.8333 20.0006 21.2222 20.0006 21.6667V58.3333C20.0006 58.7778 19.834 59.1667 19.5006 59.5C19.1673 59.8333 18.7784 60 18.334 60H15.0007ZM25.0006 60C24.5562 60 24.1673 59.8333 23.834 59.5C23.5006 59.1667 23.334 58.7778 23.334 58.3333V21.6667C23.334 21.2222 23.5006 20.8333 23.834 20.5C24.1673 20.1667 24.5562 20 25.0006 20C25.4451 20 25.834 20.1667 26.1673 20.5C26.5006 20.8333 26.6673 21.2222 26.6673 21.6667V58.3333C26.6673 58.7778 26.5006 59.1667 26.1673 59.5C25.834 59.8333 25.4451 60 25.0006 60ZM35.0006 60C34.5562 60 34.1673 59.8333 33.834 59.5C33.5007 59.1667 33.334 58.7778 33.334 58.3333V21.6667C33.334 21.2222 33.5007 20.8333 33.834 20.5C34.1673 20.1667 34.5562 20 35.0006 20H38.334C38.7784 20 39.1673 20.1667 39.5006 20.5C39.834 20.8333 40.0006 21.2222 40.0006 21.6667V58.3333C40.0006 58.7778 39.834 59.1667 39.5006 59.5C39.1673 59.8333 38.7784 60 38.334 60H35.0006ZM45.0006 60C44.5562 60 44.1673 59.8333 43.834 59.5C43.5006 59.1667 43.334 58.7778 43.334 58.3333V21.6667C43.334 21.2222 43.5006 20.8333 43.834 20.5C44.1673 20.1667 44.5562 20 45.0006 20H51.6673C52.1118 20 52.5006 20.1667 52.834 20.5C53.1673 20.8333 53.334 21.2222 53.334 21.6667V58.3333C53.334 58.7778 53.1673 59.1667 52.834 59.5C52.5006 59.8333 52.1118 60 51.6673 60H45.0006ZM58.334 60C57.8895 60 57.5006 59.8333 57.1673 59.5C56.834 59.1667 56.6673 58.7778 56.6673 58.3333V21.6667C56.6673 21.2222 56.834 20.8333 57.1673 20.5C57.5006 20.1667 57.8895 20 58.334 20C58.7784 20 59.1673 20.1667 59.5006 20.5C59.834 20.8333 60.0006 21.2222 60.0006 21.6667V58.3333C60.0006 58.7778 59.834 59.1667 59.5006 59.5C59.1673 59.8333 58.7784 60 58.334 60ZM65.0006 60C64.5562 60 64.1673 59.8333 63.834 59.5C63.5006 59.1667 63.334 58.7778 63.334 58.3333V21.6667C63.334 21.2222 63.5006 20.8333 63.834 20.5C64.1673 20.1667 64.5562 20 65.0006 20C65.4451 20 65.834 20.1667 66.1673 20.5C66.5006 20.8333 66.6673 21.2222 66.6673 21.6667V58.3333C66.6673 58.7778 66.5006 59.1667 66.1673 59.5C65.834 59.8333 65.4451 60 65.0006 60ZM20.0006 13.3333C20.0006 14.2778 19.6812 15.0694 19.0423 15.7083C18.4034 16.3472 17.6118 16.6667 16.6673 16.6667H10.0007V23.3333C10.0007 24.2778 9.68121 25.0694 9.04232 25.7083C8.40343 26.3472 7.61176 26.6667 6.66732 26.6667C5.72287 26.6667 4.93121 26.3472 4.29232 25.7083C3.65343 25.0694 3.33398 24.2778 3.33398 23.3333V13.3333C3.33398 12.3889 3.65343 11.5972 4.29232 10.9583C4.93121 10.3194 5.72287 10 6.66732 10H16.6673C17.6118 10 18.4034 10.3194 19.0423 10.9583C19.6812 11.5972 20.0006 12.3889 20.0006 13.3333ZM60.0006 13.3333C60.0006 12.3889 60.3201 11.5972 60.959 10.9583C61.5979 10.3194 62.3895 10 63.334 10H73.334C74.2784 10 75.0701 10.3194 75.709 10.9583C76.3479 11.5972 76.6673 12.3889 76.6673 13.3333V23.3333C76.6673 24.2778 76.3479 25.0694 75.709 25.7083C75.0701 26.3472 74.2784 26.6667 73.334 26.6667C72.3895 26.6667 71.5979 26.3472 70.959 25.7083C70.3201 25.0694 70.0006 24.2778 70.0006 23.3333V16.6667H63.334C62.3895 16.6667 61.5979 16.3472 60.959 15.7083C60.3201 15.0694 60.0006 14.2778 60.0006 13.3333Z"
        fill="#84919A"
      />
    </g>
  </svg>
);

export const MoreIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_25360_120435"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_25360_120435)">
      <path
        d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z"
        fill="#84919A"
      />
    </g>
  </svg>
);

export const ElipceIcon = () => (
  <svg
    width="5"
    height="6"
    viewBox="0 0 5 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2.5" cy="3" r="2.5" fill="#D5DADD" />
  </svg>
);

export const DefImgBack = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.7587 2H16.2413C17.0463 1.99999 17.7106 1.99998 18.2518 2.04419C18.8139 2.09012 19.3306 2.18868 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C21.8113 4.66937 21.9099 5.18608 21.9558 5.74817C22 6.28936 22 6.95372 22 7.75868V16.2413C22 17.0463 22 17.7106 21.9558 18.2518C21.9099 18.8139 21.8113 19.3306 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C19.3306 21.8113 18.8139 21.9099 18.2518 21.9558C17.7106 22 17.0463 22 16.2413 22H7.75868C7.73456 22 7.71056 22 7.68669 22L6.89417 22C6.62378 22 6.35801 22.0001 6.14403 21.9811C6.13603 21.9804 6.12769 21.9797 6.119 21.9788C5.98945 21.9729 5.8659 21.9654 5.74818 21.9558C5.18608 21.9099 4.66937 21.8113 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2.18868 19.3306 2.09012 18.8139 2.04419 18.2518C1.99998 17.7106 1.99999 17.0463 2 16.2413V7.7587C1.99999 6.95373 1.99998 6.28937 2.04419 5.74817C2.09012 5.18608 2.18868 4.66937 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C4.66937 2.18868 5.18608 2.09012 5.74818 2.04419C6.28937 1.99998 6.95373 1.99999 7.7587 2ZM7.8 20C7.66483 20 7.53648 20 7.41441 19.9998L15.5757 11.8385C15.7854 11.6288 15.9007 11.5146 15.9899 11.4389C15.9934 11.4359 15.9968 11.4331 16 11.4304C16.0032 11.4331 16.0066 11.4359 16.0101 11.4389C16.0993 11.5146 16.2146 11.6288 16.4243 11.8385L20 15.4142V16.2C20 17.0566 19.9992 17.6389 19.9625 18.089C19.9266 18.5274 19.8617 18.7516 19.782 18.908C19.5903 19.2843 19.2843 19.5903 18.908 19.782C18.7516 19.8617 18.5274 19.9266 18.089 19.9624C17.6389 19.9992 17.0566 20 16.2 20H7.8ZM20 12.5858L17.8159 10.4017C17.6375 10.2232 17.4637 10.0494 17.3045 9.91424C17.1296 9.76581 16.9078 9.60624 16.618 9.5121C16.2163 9.38159 15.7837 9.38159 15.382 9.5121C15.0923 9.60624 14.8704 9.76581 14.6955 9.91424C14.5363 10.0494 14.3625 10.2232 14.1841 10.4017L5.63227 18.9535C5.44105 19.1447 5.25309 19.3326 5.11519 19.4973C5.07261 19.5482 5.01522 19.6185 4.95696 19.7065C4.64245 19.5142 4.38624 19.2382 4.21799 18.908C4.1383 18.7516 4.07337 18.5274 4.03755 18.089C4.00078 17.6389 4 17.0566 4 16.2V7.8C4 6.94342 4.00078 6.36113 4.03755 5.91104C4.07337 5.47262 4.1383 5.24842 4.21799 5.09202C4.40973 4.7157 4.7157 4.40973 5.09202 4.21799C5.24842 4.1383 5.47262 4.07337 5.91104 4.03755C6.36113 4.00078 6.94342 4 7.8 4H16.2C17.0566 4 17.6389 4.00078 18.089 4.03755C18.5274 4.07337 18.7516 4.1383 18.908 4.21799C19.2843 4.40973 19.5903 4.7157 19.782 5.09202C19.8617 5.24842 19.9266 5.47262 19.9625 5.91104C19.9992 6.36113 20 6.94342 20 7.8V12.5858ZM8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5C7.5 9.05229 7.94772 9.5 8.5 9.5C9.05229 9.5 9.5 9.05229 9.5 8.5C9.5 7.94772 9.05229 7.5 8.5 7.5ZM5.5 8.5C5.5 6.84315 6.84315 5.5 8.5 5.5C10.1569 5.5 11.5 6.84315 11.5 8.5C11.5 10.1569 10.1569 11.5 8.5 11.5C6.84315 11.5 5.5 10.1569 5.5 8.5Z"
      fill="#B0BABF"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_25457_40715"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_25457_40715)">
      <path
        d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17ZM14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17Z"
        fill="#F76659"
      />
    </g>
  </svg>
);

export const InvoiceSaleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.121 2.04353C17.1974 2.21906 16.4326 2.78327 16.0439 3.57735C15.7932 4.08722 15.7305 4.3756 15.7305 4.98996C15.7305 5.60432 15.7932 5.89269 16.0439 6.41093C16.2905 6.91245 16.7962 7.41815 17.2977 7.65637C17.8034 7.89877 18.1419 7.974 18.7145 7.974C19.2954 7.974 19.6423 7.89459 20.1355 7.65637C20.428 7.51845 20.5534 7.42233 20.846 7.1256C21.4603 6.50705 21.6985 5.90523 21.6985 4.98996C21.6985 4.07469 21.4603 3.46868 20.846 2.85432C20.5576 2.56177 20.4239 2.46146 20.1355 2.32355C19.9391 2.22742 19.659 2.12294 19.5086 2.08533C19.1074 1.9892 18.5014 1.97248 18.121 2.04353ZM18.1043 3.51884C18.5306 3.76959 18.6393 4.36724 18.3258 4.72666C18.1754 4.89801 17.9163 5.03175 17.7324 5.03175C17.4607 5.03175 17.1013 4.77681 17.0052 4.51769C16.9425 4.3547 16.9467 4.05379 17.0177 3.8908C17.1932 3.48122 17.724 3.29733 18.1043 3.51884ZM19.7092 3.57735C19.7384 3.6066 19.7593 3.64839 19.7593 3.67765C19.7593 3.73198 18.2381 6.30645 18.1378 6.42347C18.05 6.52377 17.7198 6.50705 17.653 6.39839C17.5986 6.31063 17.5443 6.41093 18.539 4.74756L19.2662 3.52719H19.4626C19.5713 3.52719 19.6799 3.54809 19.7092 3.57735ZM20.0017 5.07772C20.52 5.33266 20.5743 6.11838 20.0895 6.44019C19.5671 6.78289 18.8817 6.41511 18.8817 5.79657C18.8817 5.17803 19.4501 4.81443 20.0017 5.07772Z"
      fill="#84919A"
    />
    <path
      d="M17.5951 4.07904C17.5658 4.1083 17.5449 4.16681 17.5449 4.21696C17.5449 4.26711 17.5658 4.32562 17.5951 4.35488C17.6243 4.38413 17.6828 4.40503 17.733 4.40503C17.7831 4.40503 17.8417 4.38413 17.8709 4.35488C17.9002 4.32562 17.9211 4.26711 17.9211 4.21696C17.9211 4.16681 17.9002 4.1083 17.8709 4.07904C17.8417 4.04979 17.7831 4.02889 17.733 4.02889C17.6828 4.02889 17.6243 4.04979 17.5951 4.07904Z"
      fill="#84919A"
    />
    <path
      d="M19.5431 5.62104C19.4386 5.67955 19.4428 5.89269 19.5473 5.9512C19.6601 6.00971 19.7019 6.00553 19.7771 5.92613C19.8691 5.83836 19.8607 5.67119 19.7646 5.61686C19.6643 5.5667 19.635 5.5667 19.5431 5.62104Z"
      fill="#84919A"
    />
    <path
      d="M4.63887 5.06129C4.58871 5.10308 4.53856 5.18249 4.52602 5.241C4.50513 5.33712 4.52184 5.35384 4.7726 5.4416C5.33681 5.64639 5.76728 6.01417 5.9261 6.44046C6.00969 6.66197 6.00969 6.75809 6.00969 13.0898C6.00969 20.2281 5.99297 19.806 6.29388 20.4329C6.64076 21.1475 7.25095 21.6699 7.99905 21.8873L8.21219 21.95V21.6867C8.20801 21.1642 8.48803 20.8424 9.11493 20.6502C9.83795 20.4245 10.1096 20.0024 10.2308 18.9158C10.2768 18.4853 10.3604 18.2889 10.5735 18.0841C10.8619 17.8041 10.5944 17.8208 15.1833 17.8208H19.3417V13.2235V8.63043L18.9363 8.65551C17.3482 8.74745 15.8854 7.81546 15.292 6.32344C15.1666 6.00999 15.037 5.40399 15.037 5.13233V4.99024H9.87974C5.03172 4.99024 4.71827 4.99442 4.63887 5.06129ZM12.6548 6.23986C12.6715 6.31091 12.7259 6.35688 12.8429 6.39867C13.1396 6.49897 13.3444 6.77063 13.3152 7.02139C13.3026 7.13841 13.2901 7.14259 13.0978 7.14259C12.8889 7.14259 12.8847 7.13841 12.7802 6.91691C12.7677 6.88347 12.73 6.84586 12.705 6.8375C12.6715 6.82914 12.6548 6.90437 12.6548 7.09244V7.3641L12.8387 7.41007C13.0644 7.4644 13.2984 7.71098 13.3653 7.95756C13.4698 8.35042 13.2316 8.75999 12.822 8.88119C12.6757 8.92716 12.6548 8.94806 12.6548 9.05254C12.6548 9.13613 12.6256 9.18628 12.5545 9.21554C12.4124 9.28241 12.2787 9.203 12.2787 9.04836C12.2787 8.94806 12.2536 8.92299 12.1157 8.88537C11.7813 8.78089 11.5515 8.4758 11.5766 8.15399L11.5891 7.97846L11.7939 7.96592C12.0154 7.9492 12.0697 7.98682 12.0697 8.17071C12.0697 8.22922 12.1157 8.32116 12.1742 8.37549L12.2787 8.47162V8.14145V7.81128L12.0906 7.73606C11.6392 7.54799 11.4846 7.08408 11.7354 6.67033C11.8315 6.51569 12.0488 6.36942 12.1867 6.36942C12.2536 6.36942 12.2787 6.34434 12.2787 6.27329C12.2787 6.13955 12.3163 6.11448 12.4835 6.12701C12.6005 6.13537 12.6339 6.16045 12.6548 6.23986ZM9.91736 9.44122C10.0218 9.54153 10.0218 9.54988 10.0218 10.3398C10.0218 11.4139 10.0929 11.3428 9.0188 11.3428C7.94471 11.3428 8.01576 11.4139 8.01576 10.3398C8.01576 9.26569 7.94471 9.33674 9.0188 9.33674C9.80869 9.33674 9.81705 9.33674 9.91736 9.44122ZM17.273 10.1099C17.3398 10.1726 17.3775 10.2604 17.3775 10.3398C17.3775 10.4192 17.3398 10.507 17.273 10.5696L17.1727 10.6741H13.8668H10.561L10.4607 10.5696C10.3938 10.507 10.3562 10.4192 10.3562 10.3398C10.3562 10.2604 10.3938 10.1726 10.4607 10.1099L10.561 10.0054H13.8668H17.1727L17.273 10.1099ZM9.91736 11.7816C10.0218 11.8819 10.0218 11.8903 10.0218 12.6802C10.0218 13.4701 10.0218 13.4785 9.91736 13.5788C9.81705 13.6832 9.80869 13.6832 9.0188 13.6832C7.94471 13.6832 8.01576 13.7543 8.01576 12.6802C8.01576 11.6061 7.94471 11.6772 9.0188 11.6772C9.80869 11.6772 9.81705 11.6772 9.91736 11.7816ZM17.273 12.4503C17.3398 12.513 17.3775 12.6008 17.3775 12.6802C17.3775 12.7596 17.3398 12.8474 17.273 12.9101L17.1727 13.0145H13.8668H10.561L10.4607 12.9101C10.3938 12.8474 10.3562 12.7596 10.3562 12.6802C10.3562 12.6008 10.3938 12.513 10.4607 12.4503L10.561 12.3459H13.8668H17.1727L17.273 12.4503ZM9.91736 14.1221C10.0218 14.2224 10.0218 14.2307 10.0218 15.0206C10.0218 16.0947 10.0929 16.0237 9.0188 16.0237C7.94471 16.0237 8.01576 16.0947 8.01576 15.0206C8.01576 14.2307 8.01576 14.2224 8.12025 14.1221C8.22055 14.0176 8.22891 14.0176 9.0188 14.0176C9.80869 14.0176 9.81705 14.0176 9.91736 14.1221ZM17.273 14.7908C17.3398 14.8535 17.3775 14.9412 17.3775 15.0206C17.3775 15.1 17.3398 15.1878 17.273 15.2505L17.1727 15.355H13.8668H10.561L10.4607 15.2505C10.3938 15.1878 10.3562 15.1 10.3562 15.0206C10.3562 14.9412 10.3938 14.8535 10.4607 14.7908L10.561 14.6863H13.8668H17.1727L17.273 14.7908ZM9.91736 16.4625C10.0218 16.5628 10.0218 16.5712 10.0218 17.361C10.0218 18.4351 10.0929 18.3641 9.0188 18.3641C7.94471 18.3641 8.01576 18.4351 8.01576 17.361C8.01576 16.5712 8.01576 16.5628 8.12025 16.4625C8.22055 16.358 8.22891 16.358 9.0188 16.358C9.80869 16.358 9.81705 16.358 9.91736 16.4625ZM17.273 17.1312C17.3398 17.1939 17.3775 17.2816 17.3775 17.361C17.3775 17.4405 17.3398 17.5282 17.273 17.5909L17.1727 17.6954H13.8668H10.561L10.4607 17.5909C10.3938 17.5282 10.3562 17.4405 10.3562 17.361C10.3562 17.2816 10.3938 17.1939 10.4607 17.1312L10.561 17.0267H13.8668H17.1727L17.273 17.1312Z"
      fill="#84919A"
    />
    <path
      d="M12.1493 6.92953C12.0908 7.05074 12.1284 7.23045 12.2161 7.26388C12.2663 7.2806 12.2788 7.24298 12.2788 7.05909C12.2788 6.81669 12.2245 6.76236 12.1493 6.92953Z"
      fill="#84919A"
    />
    <path
      d="M12.6562 8.18743C12.6562 8.47162 12.6813 8.50924 12.7942 8.38386C12.8987 8.26684 12.9028 8.08295 12.7983 7.98264C12.6855 7.86562 12.6562 7.90741 12.6562 8.18743Z"
      fill="#84919A"
    />
    <path
      d="M3.82458 6.05173C3.44426 6.19382 3.14335 6.50727 3.04305 6.87088C2.98036 7.0882 2.98872 9.09846 3.05141 9.3116C3.11827 9.54147 3.46516 9.88835 3.69502 9.95522C3.80368 9.98447 4.15057 10.0054 4.60612 10.0054H5.34586L5.33332 8.42559L5.32078 6.84998L5.20794 6.64101C5.07838 6.39025 4.92792 6.24398 4.67298 6.1186C4.43894 6.00157 4.04191 5.96814 3.82458 6.05173Z"
      fill="#84919A"
    />
    <path
      d="M11.026 18.573C10.934 18.6649 10.9257 18.6983 10.8588 19.2416C10.7251 20.3533 10.2779 20.9593 9.3459 21.2728C8.96976 21.4024 8.89453 21.465 8.89453 21.6698C8.89453 21.791 8.91961 21.8454 9.00319 21.9122C9.11604 22 9.12021 22 14.1062 22H19.0963L19.4181 21.8913C19.882 21.7367 20.162 21.5653 20.4922 21.231C21.0104 20.7086 21.2946 19.9981 21.374 19.041C21.3991 18.7192 21.3991 18.7025 21.2946 18.598L21.1859 18.4894H16.1457C11.189 18.4894 11.1096 18.4894 11.026 18.573Z"
      fill="#84919A"
    />
  </svg>
);

export const PriceTagIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35712 1.08073C8.25815 1.13236 8.15918 1.23133 8.10754 1.3346C8.02579 1.49381 8.02148 1.58417 8.02148 2.9267V4.34668L8.27966 4.21759C8.42166 4.14874 8.59378 4.0885 8.66693 4.0885C8.74008 4.0885 8.9122 4.14874 9.0542 4.21759L9.31238 4.34668V2.9267C9.31238 1.58417 9.30807 1.49381 9.22632 1.3346C9.06711 1.02048 8.67984 0.908607 8.35712 1.08073Z"
      fill="#84919A"
    />
    <path
      d="M11.9983 4.38092C12.0112 4.40244 12.7126 4.81552 13.5559 5.29745C14.9415 6.0849 15.1308 6.20968 15.4535 6.51089C15.9828 7.01434 16.284 7.50488 16.5078 8.23208L16.6067 8.54189L16.6283 13.7141L16.6498 18.8862L17.661 18.301C18.2161 17.9826 19.0594 17.4964 19.5328 17.221C20.2255 16.8208 20.4493 16.6702 20.673 16.4421C21.3056 15.801 21.5207 14.85 21.2238 14.0282C21.1679 13.8733 20.0276 11.8509 18.6937 9.53588C16 4.86716 16.0646 4.96182 15.4363 4.6348C14.9458 4.37662 14.722 4.3465 13.259 4.3465C12.5533 4.3465 11.9854 4.36371 11.9983 4.38092Z"
      fill="#84919A"
    />
    <path
      d="M5.46067 5.81824C3.17149 7.12635 2.94343 7.26834 2.68095 7.53083C2.51313 7.69864 2.34532 7.9267 2.26356 8.08591C1.97957 8.6539 1.99247 8.33118 2.00538 15.061L2.01829 21.1497L2.11726 21.4036C2.39265 22.1351 2.92192 22.6558 3.6233 22.901L3.9116 23H8.66638H13.4212L13.7095 22.901C14.4108 22.6558 14.9401 22.1351 15.2155 21.4036L15.3145 21.1497L15.3274 15.0395C15.336 9.06268 15.336 8.92499 15.2499 8.59366C15.1423 8.15906 14.953 7.83203 14.6303 7.50501C14.3979 7.27695 14.058 7.07041 11.8678 5.81824C10.4908 5.0308 9.35485 4.38966 9.33764 4.38966C9.32473 4.38966 9.31182 5.19431 9.31182 6.17539V7.96112H9.69909C10.0046 7.96112 10.1251 7.97833 10.2585 8.04718C10.4521 8.14615 10.6027 8.39142 10.6027 8.60657C10.6027 8.82172 10.4521 9.06699 10.2585 9.16595C10.0993 9.24771 10.0089 9.25201 8.66208 9.25201C7.26361 9.25201 7.23349 9.25201 7.06567 9.15735C6.75586 8.98093 6.65259 8.62808 6.8161 8.30536C6.94949 8.04718 7.15173 7.96112 7.63367 7.96112H8.02093V6.17539C8.02093 5.19431 8.00802 4.38966 7.99081 4.38966C7.9693 4.38966 6.83331 5.0351 5.46067 5.81824ZM7.21628 11.3906C8.76965 12.1221 8.79977 14.5447 7.25931 15.3063C6.98822 15.4397 6.88495 15.4655 6.58374 15.4827C6.13193 15.5042 5.83933 15.4268 5.47358 15.1772C4.7808 14.7039 4.42365 13.8003 4.59147 12.9483C4.63019 12.7546 4.72056 12.4663 4.79801 12.3157C5.03467 11.8381 5.56394 11.3949 6.05448 11.2701C6.13193 11.2529 6.35568 11.24 6.55792 11.2443C6.86774 11.2572 6.97101 11.2787 7.21628 11.3906ZM10.6845 11.5197C10.8953 11.6789 10.9685 11.8252 10.9599 12.0619C10.9556 12.2512 10.7017 12.8837 9.31613 16.1755C8.41681 18.3141 7.64658 20.1127 7.60785 20.1729C7.50888 20.3193 7.19046 20.4526 7.01834 20.4139C6.6698 20.3408 6.47187 20.117 6.47187 19.79C6.47187 19.6437 6.8075 18.8089 8.1156 15.685C9.01922 13.5335 9.78945 11.7262 9.82388 11.6746C10.0046 11.4164 10.4392 11.339 10.6845 11.5197ZM11.4504 16.6101C12.4702 16.9629 13.0425 18.2581 12.6638 19.3726C12.3282 20.3752 11.36 20.9604 10.4306 20.7237C9.17413 20.401 8.5545 18.8691 9.16552 17.6084C9.23007 17.4793 9.39358 17.2512 9.53558 17.1006C10.0519 16.5498 10.749 16.3691 11.4504 16.6101Z"
      fill="#84919A"
    />
    <path
      d="M6.18358 12.6125C5.84795 12.8277 5.73607 13.4731 5.96843 13.869C6.16207 14.2003 6.48909 14.295 6.77309 14.1013C6.99254 13.955 7.09581 13.7184 7.09581 13.3612C7.09581 13.1375 7.06999 13.0127 7.00545 12.8879C6.82903 12.548 6.47188 12.4275 6.18358 12.6125Z"
      fill="#84919A"
    />
    <path
      d="M10.7015 17.8191C10.5379 17.8664 10.3314 18.1031 10.2626 18.3268C10.056 19.0282 10.6197 19.7382 11.1189 19.3983C11.4846 19.1487 11.6051 18.5592 11.3684 18.1547C11.192 17.8535 10.9725 17.7459 10.7015 17.8191Z"
      fill="#84919A"
    />
  </svg>
);

export const TrolleyICon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_22_30688"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_22_30688)">
      <path
        d="M20 17H6C5.45 17 4.97933 16.8043 4.588 16.413C4.196 16.021 4 15.55 4 15V5H3C2.71667 5 2.47933 4.904 2.288 4.712C2.096 4.52067 2 4.28333 2 4C2 3.71667 2.096 3.479 2.288 3.287C2.47933 3.09567 2.71667 3 3 3H4C4.55 3 5.02067 3.19567 5.412 3.587C5.804 3.979 6 4.45 6 5V15H20C20.2833 15 20.5207 15.0957 20.712 15.287C20.904 15.479 21 15.7167 21 16C21 16.2833 20.904 16.5207 20.712 16.712C20.5207 16.904 20.2833 17 20 17ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20C4 19.45 4.196 18.979 4.588 18.587C4.97933 18.1957 5.45 18 6 18C6.55 18 7.02067 18.1957 7.412 18.587C7.804 18.979 8 19.45 8 20C8 20.55 7.804 21.021 7.412 21.413C7.02067 21.8043 6.55 22 6 22ZM8 14C7.71667 14 7.479 13.904 7.287 13.712C7.09567 13.5207 7 13.2833 7 13V9C7 8.71667 7.09567 8.479 7.287 8.287C7.479 8.09567 7.71667 8 8 8H12C12.2833 8 12.521 8.09567 12.713 8.287C12.9043 8.479 13 8.71667 13 9V13C13 13.2833 12.9043 13.5207 12.713 13.712C12.521 13.904 12.2833 14 12 14H8ZM15 14C14.7167 14 14.4793 13.904 14.288 13.712C14.096 13.5207 14 13.2833 14 13V9C14 8.71667 14.096 8.479 14.288 8.287C14.4793 8.09567 14.7167 8 15 8H19C19.2833 8 19.5207 8.09567 19.712 8.287C19.904 8.479 20 8.71667 20 9V13C20 13.2833 19.904 13.5207 19.712 13.712C19.5207 13.904 19.2833 14 19 14H15ZM19 22C18.45 22 17.979 21.8043 17.587 21.413C17.1957 21.021 17 20.55 17 20C17 19.45 17.1957 18.979 17.587 18.587C17.979 18.1957 18.45 18 19 18C19.55 18 20.021 18.1957 20.413 18.587C20.8043 18.979 21 19.45 21 20C21 20.55 20.8043 21.021 20.413 21.413C20.021 21.8043 19.55 22 19 22Z"
        fill="#84919A"
      />
    </g>
  </svg>
);

export const ChevronRightICon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
      fill="#B0BABF"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_32_2772"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_32_2772)">
      <path
        d="M11.9998 13.4L7.0998 18.3C6.91647 18.4834 6.68314 18.575 6.3998 18.575C6.11647 18.575 5.88314 18.4834 5.6998 18.3C5.51647 18.1167 5.4248 17.8834 5.4248 17.6C5.4248 17.3167 5.51647 17.0834 5.6998 16.9L10.5998 12L5.6998 7.10005C5.51647 6.91672 5.4248 6.68338 5.4248 6.40005C5.4248 6.11672 5.51647 5.88338 5.6998 5.70005C5.88314 5.51672 6.11647 5.42505 6.3998 5.42505C6.68314 5.42505 6.91647 5.51672 7.0998 5.70005L11.9998 10.6L16.8998 5.70005C17.0831 5.51672 17.3165 5.42505 17.5998 5.42505C17.8831 5.42505 18.1165 5.51672 18.2998 5.70005C18.4831 5.88338 18.5748 6.11672 18.5748 6.40005C18.5748 6.68338 18.4831 6.91672 18.2998 7.10005L13.3998 12L18.2998 16.9C18.4831 17.0834 18.5748 17.3167 18.5748 17.6C18.5748 17.8834 18.4831 18.1167 18.2998 18.3C18.1165 18.4834 17.8831 18.575 17.5998 18.575C17.3165 18.575 17.0831 18.4834 16.8998 18.3L11.9998 13.4Z"
        fill="#B0BABF"
      />
    </g>
  </svg>
);

export const CanselCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_34_3418"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_34_3418)">
      <path
        d="M9.99935 11.1666L12.416 13.5833C12.5688 13.7361 12.7632 13.8125 12.9993 13.8125C13.2355 13.8125 13.4299 13.7361 13.5827 13.5833C13.7355 13.4305 13.8118 13.2361 13.8118 13C13.8118 12.7638 13.7355 12.5694 13.5827 12.4166L11.166 9.99996L13.5827 7.58329C13.7355 7.43052 13.8118 7.23607 13.8118 6.99996C13.8118 6.76385 13.7355 6.5694 13.5827 6.41663C13.4299 6.26385 13.2355 6.18746 12.9993 6.18746C12.7632 6.18746 12.5688 6.26385 12.416 6.41663L9.99935 8.83329L7.58268 6.41663C7.4299 6.26385 7.23546 6.18746 6.99935 6.18746C6.76324 6.18746 6.56879 6.26385 6.41602 6.41663C6.26324 6.5694 6.18685 6.76385 6.18685 6.99996C6.18685 7.23607 6.26324 7.43052 6.41602 7.58329L8.83268 9.99996L6.41602 12.4166C6.26324 12.5694 6.18685 12.7638 6.18685 13C6.18685 13.2361 6.26324 13.4305 6.41602 13.5833C6.56879 13.7361 6.76324 13.8125 6.99935 13.8125C7.23546 13.8125 7.4299 13.7361 7.58268 13.5833L9.99935 11.1666ZM9.99935 18.3333C8.84657 18.3333 7.76324 18.1145 6.74935 17.677C5.73546 17.2395 4.85352 16.6458 4.10352 15.8958C3.35352 15.1458 2.75977 14.2638 2.32227 13.25C1.88477 12.2361 1.66602 11.1527 1.66602 9.99996C1.66602 8.84718 1.88477 7.76385 2.32227 6.74996C2.75977 5.73607 3.35352 4.85413 4.10352 4.10413C4.85352 3.35413 5.73546 2.76038 6.74935 2.32288C7.76324 1.88538 8.84657 1.66663 9.99935 1.66663C11.1521 1.66663 12.2355 1.88538 13.2493 2.32288C14.2632 2.76038 15.1452 3.35413 15.8952 4.10413C16.6452 4.85413 17.2389 5.73607 17.6764 6.74996C18.1139 7.76385 18.3327 8.84718 18.3327 9.99996C18.3327 11.1527 18.1139 12.2361 17.6764 13.25C17.2389 14.2638 16.6452 15.1458 15.8952 15.8958C15.1452 16.6458 14.2632 17.2395 13.2493 17.677C12.2355 18.1145 11.1521 18.3333 9.99935 18.3333Z"
        fill="white"
      />
    </g>
  </svg>
);

export const CategoryPlusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_52_35446"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_52_35446)">
      <path
        d="M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z"
        fill="#9103E4"
      />
    </g>
  </svg>
);

export const PaymentPlusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_62_28926"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_62_28926)">
      <path
        d="M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z"
        fill="#84919A"
      />
    </g>
  </svg>
);

export const PaymentFormCloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_82_28977"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_82_28977)">
      <path
        d="M12.0008 13.4L7.10078 18.3C6.91745 18.4833 6.68411 18.575 6.40078 18.575C6.11745 18.575 5.88411 18.4833 5.70078 18.3C5.51745 18.1167 5.42578 17.8833 5.42578 17.6C5.42578 17.3167 5.51745 17.0833 5.70078 16.9L10.6008 12L5.70078 7.09999C5.51745 6.91665 5.42578 6.68332 5.42578 6.39999C5.42578 6.11665 5.51745 5.88332 5.70078 5.69999C5.88411 5.51665 6.11745 5.42499 6.40078 5.42499C6.68411 5.42499 6.91745 5.51665 7.10078 5.69999L12.0008 10.6L16.9008 5.69999C17.0841 5.51665 17.3174 5.42499 17.6008 5.42499C17.8841 5.42499 18.1174 5.51665 18.3008 5.69999C18.4841 5.88332 18.5758 6.11665 18.5758 6.39999C18.5758 6.68332 18.4841 6.91665 18.3008 7.09999L13.4008 12L18.3008 16.9C18.4841 17.0833 18.5758 17.3167 18.5758 17.6C18.5758 17.8833 18.4841 18.1167 18.3008 18.3C18.1174 18.4833 17.8841 18.575 17.6008 18.575C17.3174 18.575 17.0841 18.4833 16.9008 18.3L12.0008 13.4Z"
        fill="#F76659"
      />
    </g>
  </svg>
);

export const ContactIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_84_29286"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_84_29286)">
      <path
        d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 18V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z"
        fill="#84919A"
      />
    </g>
  </svg>
);
